import HorizontalRule from "./HorizontalRule";

## As Section Divider

<div>
  <p>First section content goes here.</p>
  <HorizontalRule />
  <p>Second section content goes here.</p>
</div>

## In a List Context

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <div>Item 1</div>
  <HorizontalRule />
  <div>Item 2</div>
  <HorizontalRule />
  <div>Item 3</div>
</div>

## With Custom Styling

<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>Default:</p>
    <HorizontalRule />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>With margin:</p>
    <HorizontalRule style={{ margin: "1rem 0" }} />
  </div>
</div>

---

## Menu Separator Example

<div
  style={{ background: "#fff", border: "1px solid #e5e5e5", borderRadius: "8px", padding: "0.5rem", maxWidth: "200px" }}
>
  <div style={{ padding: "0.5rem" }}>Edit</div>
  <div style={{ padding: "0.5rem" }}>Duplicate</div>
  <HorizontalRule />
  <div style={{ padding: "0.5rem" }}>Move to...</div>
  <div style={{ padding: "0.5rem" }}>Copy to...</div>
  <HorizontalRule />
  <div style={{ padding: "0.5rem", color: "#dc2626" }}>Delete</div>
</div>
